var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWindowsLogo = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_58_328)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 2.8125V8.4375H7.875V1.82812L0 2.8125Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 1.6875V8.4375H18V0.5625L9 1.6875Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 9.5625V16.3125L18 17.4375V9.5625H9Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 9.5625V15.1875L7.875 16.1719V9.5625H0Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_58_328"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWindowsLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "519e41074b4fa5fd9473ccd71c2ec067.svg";